module.exports = __webpack_public_path__ + "img/大风.55a1b4fa.png";